import { createOssAssetsUrl } from '@/utils/createOssAssetsUrl';

export const IMAGE_NOT_FOUND = createOssAssetsUrl(
  '/assets/img/cms-web/notFound.svg',
);
